import { useContext, useEffect, useState } from "react";
import { MsalTokenContext } from "../contexts/MsalTokenProvider";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../providers/authProvider";

const TokenHelper = ({children}) => {
    const tokenCtx = useContext(MsalTokenContext);
    const {instance, inProgress} = useMsal();
    const [initialized, setInitialized] = useState(false);
   
    useEffect(()=>{
        const initializeMsal = async () => {
          await instance.initialize();
          setInitialized(true);
        }
        initializeMsal();
      },[]);
   
      const getAccessToken = async () => {
        if(!initialized)
          return;
   
        else{
          let acc = instance.getActiveAccount();
          let accessToken;
          if(acc){
            await instance.acquireTokenSilent({
                scopes:loginRequest.scopes,            
                account: acc??undefined,
                forceRefresh: true
              })
              .then(response => {
                accessToken = response.accessToken;
                tokenCtx?.updateAccessToken(accessToken);
              })
            .catch(error => console.log(error))
        }
      }}
   
      useEffect(() => {
        if (initialized) {
          getAccessToken();
        }
      }, [initialized, inProgress]);
   
 
    return <>{children}</>
}

export default TokenHelper;
